"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[444],{

/***/ 10925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SR": function() { return /* binding */ parsePhoneNumber; }
/* harmony export */ });
/* unused harmony exports isValidPhoneNumber, getCountry */
/* harmony import */ var _phoneNumberUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35070);
// Generated by ReScript, PLEASE EDIT WITH CARE

var isValidPhoneNumber = _phoneNumberUtils__WEBPACK_IMPORTED_MODULE_0__/* .validateMobileNumber */ .n6;
var parsePhoneNumber = _phoneNumberUtils__WEBPACK_IMPORTED_MODULE_0__/* .toPhoneInputFormat */ .M2;
var getCountry = _phoneNumberUtils__WEBPACK_IMPORTED_MODULE_0__/* .getCountryFromNumber */ .mY;
 /* isValidPhoneNumber Not a pure module */ 


/***/ }),

/***/ 35070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M2": function() { return /* binding */ toPhoneInputFormat; },
/* harmony export */   "mY": function() { return /* binding */ getCountryFromNumber; },
/* harmony export */   "n6": function() { return /* binding */ validateMobileNumber; }
/* harmony export */ });
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58805);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6898);



var validateMobileNumber = function(countryCode, mobileNumber) {
    if (!mobileNumber || !mobileNumber.trim()) {
        return true;
    }
    return (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_0__/* .isValidPhoneNumber */ .y)(mobileNumber.replaceAll(/\s/g, ""));
};
var defaultPhoneInputValue = {
    countryCode: ("NZ" || 0).toLocaleLowerCase(),
    number: ""
};
var getCountryFromNumber = function(number) {
    return (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_1__/* .parsePhoneNumber */ .S)(number);
};
var toPhoneInputFormat = function(number) {
    if (!number || !number.trim()) {
        return defaultPhoneInputValue;
    }
    var res = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_1__/* .parsePhoneNumber */ .S)(number, {
        extract: false
    });
    if (!res) {
        return defaultPhoneInputValue;
    }
    return {
        countryCode: (res.country || "").toLocaleLowerCase(),
        number: res.number
    };
};


/***/ }),

/***/ 93106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20859);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE



function ErrorFieldText(props) {
    var error = props.error;
    if (error !== undefined) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
            children: error,
            className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                "block text-xs text-left mt-1 mb-2 text-prezzee-red",
                _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(props.className, "")
            ])
        });
    } else {
        return null;
    }
}
var make = ErrorFieldText;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 37595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ TSXComponent; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js + 1 modules
var exports_parsePhoneNumber = __webpack_require__(58805);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/FormInputPhoneNumber/index.js
var FormInputPhoneNumber = __webpack_require__(22769);
// EXTERNAL MODULE: ./src/common/util.ts + 3 modules
var util = __webpack_require__(42358);
// EXTERNAL MODULE: ./src/bindings/phoneNumberUtils.js
var phoneNumberUtils = __webpack_require__(35070);
;// CONCATENATED MODULE: ./src/components/forms/PhoneField.tsx






var PhoneField = function(param) {
    var defaultCountry = param.defaultCountry, defaultNumber = param.defaultNumber, disabled = param.disabled, error = param.error, fieldOnBlur = param.fieldOnBlur, fieldOnChange = param.fieldOnChange, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? true : _mobileOnly;
    var ref;
    var ref1 = (0,react.useState)(function() {
        if (defaultNumber) return (0,exports_parsePhoneNumber/* parsePhoneNumber */.S)(defaultNumber);
        return null;
    }), phoneNumber = ref1[0], setPhoneNumber = ref1[1];
    var ref2 = (0,react.useState)(false), hasUserInput = ref2[0], setHasUserInput = ref2[1];
    var ref3 = (0,react.useState)(""), placeholderNumber = ref3[0], setPlaceholderNumber = ref3[1];
    var inputCountry = (defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.toUpperCase()) || util/* envUtil.getCountry */.vK.getCountry();
    var countryCode = "AU";
    switch(inputCountry){
        case util/* COUNTRY.UnitedStates */.si.UnitedStates:
            countryCode = "US";
            break;
        case util/* COUNTRY.GreatBritain */.si.GreatBritain:
            countryCode = "GB";
            break;
        case util/* COUNTRY.NewZealand */.si.NewZealand:
            countryCode = "NZ";
            break;
    }
    var reset = function() {
        setHasUserInput(false);
        setPlaceholderNumber("");
        setPhoneNumber(null);
    };
    var parsePhoneNumber = (0,react.useCallback)(function() {
        if (!phoneNumber) {
            if (placeholderNumber) {
                return {
                    number: placeholderNumber,
                    countryCode: ""
                };
            }
            return null;
        }
        var country = phoneNumber.country, number = phoneNumber.number;
        if (country && number) {
            var isValidNumber = mobileOnly ? (0,phoneNumberUtils/* validateMobileNumber */.n6)(country, number) : true;
            if (isValidNumber) {
                return {
                    countryCode: country,
                    number: number
                };
            }
        } else if (hasUserInput) {
            return {
                number: number !== null && number !== void 0 ? number : placeholderNumber,
                countryCode: country !== null && country !== void 0 ? country : ""
            };
        } else {
            return null;
        }
    }, [
        hasUserInput,
        phoneNumber,
        placeholderNumber
    ]);
    var blurHandler = function() {
        fieldOnBlur === null || fieldOnBlur === void 0 ? void 0 : fieldOnBlur(parsePhoneNumber());
    };
    var changeHandler = function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var codeAndNumber = value.split(" ");
        if (codeAndNumber.length < 2) {
            // only has country code from dropdown
            reset();
        } else {
            setHasUserInput(true);
            setPlaceholderNumber(codeAndNumber[1].replace(/\s/g, ""));
            var ref;
            setPhoneNumber((ref = (0,exports_parsePhoneNumber/* parsePhoneNumber */.S)(value)) !== null && ref !== void 0 ? ref : null);
        }
    };
    (0,react.useEffect)(function() {
        fieldOnChange(parsePhoneNumber());
    }, [
        hasUserInput,
        phoneNumber,
        placeholderNumber
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FormInputPhoneNumber/* default */.Z, {
        defaultCountry: countryCode,
        defaultNumber: phoneNumber === null || phoneNumber === void 0 ? void 0 : (ref = phoneNumber.number) === null || ref === void 0 ? void 0 : ref.toString(),
        disabled: disabled,
        countryCodes: "all",
        errorMessage: error,
        onBlur: blurHandler,
        onChange: changeHandler
    });
};
/* harmony default export */ var forms_PhoneField = (PhoneField);

;// CONCATENATED MODULE: ./src/components/forms/PhoneField.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = forms_PhoneField;
var TSXComponent = {
    make: make
};
 /* make Not a pure module */ 


/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25400);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20949);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71434);
// Generated by ReScript, PLEASE EDIT WITH CARE







function $$Notification(props) {
    var notificationType = props.notificationType;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                    children: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .icon */ .qv(notificationType)
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
                    children: [
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(props.title, null, function(title) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("p", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(title),
                                className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .titleStyle */ .E3
                            });
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("p", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(props.description),
                            className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .descriptionStyle */ .ab
                        }),
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(props.markdown, null, function(m) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(react_markdown__WEBPACK_IMPORTED_MODULE_4__/* .Markdown */ .UG, {
                                children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(m))
                            });
                        })
                    ]
                })
            ],
            className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .innerContainer */ .OM
        }),
        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S([
            _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rootContainer */ .$2(notificationType),
            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .getWithDefault */ .tj(props.className, "")
        ]),
        role: "alert"
    });
}
var make = $$Notification;
 /* Util Not a pure module */ 


/***/ }),

/***/ 71434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rootContainer; },
/* harmony export */   "E3": function() { return /* binding */ titleStyle; },
/* harmony export */   "OM": function() { return /* binding */ innerContainer; },
/* harmony export */   "ab": function() { return /* binding */ descriptionStyle; },
/* harmony export */   "qv": function() { return /* binding */ icon; }
/* harmony export */ });
/* unused harmony exports container, notificationStyle */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20859);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE


var container = "rounded-lg px-4 py-5 max-w-3xl text-left mx-auto";
var notificationStyle = "fill-current h-6 w-6 mr-4";
function rootContainer(notificationType) {
    switch(notificationType){
        case /* NotificationError */ 0:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-error-pink"
            ]);
        case /* NotificationInfo */ 1:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-info-blue"
            ]);
        case /* NotificationSuccess */ 2:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-success-green"
            ]);
        case /* NotificationWarning */ 3:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-warning-orange"
            ]);
    }
}
function icon(notificationType) {
    switch(notificationType){
        case /* NotificationError */ 0:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs("svg", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("mask", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                            d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM22.3477 20.25L20.25 22.3477L15 17.0977L9.75 22.3477L7.65234 20.25L12.9023 15L7.65234 9.75L9.75 7.65234L15 12.9023L20.25 7.65234L22.3477 9.75L17.0977 15L22.3477 20.25Z",
                            fill: "white"
                        }),
                        id: "mask0",
                        height: "30",
                        width: "30",
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("g", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                            d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM22.3477 20.25L20.25 22.3477L15 17.0977L9.75 22.3477L7.65234 20.25L12.9023 15L7.65234 9.75L9.75 7.65234L15 12.9023L20.25 7.65234L22.3477 9.75L17.0977 15L22.3477 20.25Z",
                            fill: "#C20D16"
                        }),
                        mask: "url(#mask0)"
                    })
                ],
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationInfo */ 1:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 30C18.9781 30 22.7931 28.4192 25.6066 25.6066C28.4191 22.7928 30 18.9781 30 15C30 11.0219 28.4192 7.20687 25.6066 4.39344C22.7928 1.58094 18.9781 0 15 0C11.0219 0 7.20687 1.58081 4.39344 4.39344C1.58094 7.20716 0 11.0219 0 15C0 18.9781 1.58081 22.7931 4.39344 25.6066C7.20716 28.4191 11.0219 30 15 30ZM15 6.5625C15.7581 6.5625 16.4417 7.01903 16.7322 7.71972C17.0227 8.42041 16.8616 9.22728 16.3257 9.76319C15.7898 10.2991 14.9829 10.4602 14.2822 10.1697C13.5815 9.87916 13.125 9.19556 13.125 8.4375C13.125 7.40234 13.9648 6.5625 15 6.5625ZM13.125 13.125L16.875 13.125V23.4375H13.125L13.125 13.125Z",
                    fill: "#2E5299",
                    fillRule: "evenodd"
                }),
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationSuccess */ 2:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM20.7973 9L12.8003 16.9949L9.10428 13.6131L7 15.9122L12.8957 21.3069L23 11.2027L20.7973 9Z",
                    fill: "#25AE88",
                    fillRule: "evenodd"
                }),
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationWarning */ 3:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 0C11.0219 0 7.20688 1.58081 4.39344 4.39344C1.58094 7.20716 0 11.0219 0 15C0 18.9781 1.58081 22.7931 4.39344 25.6066C7.20716 28.4191 11.0219 30 15 30C18.9781 30 22.7931 28.4192 25.6066 25.6066C28.4191 22.7928 30 18.9781 30 15C30 11.0219 28.4192 7.20687 25.6066 4.39344C22.7928 1.58094 18.9781 0 15 0ZM15 23.4375C14.2419 23.4375 13.5583 22.981 13.2678 22.2803C12.9773 21.5796 13.1384 20.7727 13.6743 20.2368C14.2102 19.7009 15.0171 19.5398 15.7178 19.8303C16.4185 20.1208 16.875 20.8044 16.875 21.5625C16.875 22.5977 16.0352 23.4375 15 23.4375ZM16.875 16.875H13.125V6.5625H16.875V16.875Z",
                    fill: "#DC5800",
                    fillRule: "evenodd"
                }),
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                    notificationStyle,
                    "text-teal-500"
                ]),
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
    }
}
var innerContainer = "flex";
var titleStyle = "font-bold text-lg text-dark-gray pb-1";
var descriptionStyle = "text-base text-dark-gray";
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 31292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Styles, getSignupType */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(20859);
/* harmony import */ var bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90289);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(92592);
/* harmony import */ var _css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93802);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(94518);
/* harmony import */ var _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73840);
/* harmony import */ var _auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45603);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(72491);
/* harmony import */ var _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43243);
/* harmony import */ var _utils_FormReducer_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40367);
/* harmony import */ var _auth_user_UserContext_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81098);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Notification_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88767);
/* harmony import */ var _bindings_ReactHookForm_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77103);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42283);
/* harmony import */ var _pages_register_steps_SignUpStepStyles_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96626);
/* harmony import */ var _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37110);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85893);
/* harmony import */ var _api_PrezzeePublicClient_bs_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47861);
/* harmony import */ var _api_PrezzeeSecureClient_bs_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68213);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(10573);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(78078);
/* harmony import */ var _prezzee_ribbon_ui_lib_components_FormInputPin__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(32693);
// Generated by ReScript, PLEASE EDIT WITH CARE


























var nestedInput = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("flex")),
    tl: {
        hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("input", {
            hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
            tl: {
                hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.charcoal */ .Il.charcoal),
                tl: {
                    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderRadius */ .E0l(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(6)),
                    tl: {
                        hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
                        tl: {
                            hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .height */ .Cb8(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
                            tl: {
                                hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .boxSizing */ .ixg("borderBox"),
                                tl: {
                                    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(32)),
                                    tl: {
                                        hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(4)),
                                        tl: {
                                            hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderWidth */ .J4J(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(2)),
                                            tl: {
                                                hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderStyle */ .$uf("solid"),
                                                tl: {
                                                    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderColor */ .tvt(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.gray300 */ .Il.gray300),
                                                    tl: {
                                                        hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingBottom */ .EtG(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(4)),
                                                        tl: {
                                                            hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("center"),
                                                            tl: {
                                                                hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .flex */ .fUN({
                                                                    NAME: "num",
                                                                    VAL: 1
                                                                }),
                                                                tl: {
                                                                    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .outline */ .Kl7(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(0), "solid", "transparent"),
                                                                    tl: {
                                                                        hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .focus */ .T_4({
                                                                            hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderColor */ .tvt(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.blue400 */ .Il.blue400),
                                                                            tl: /* [] */ 0
                                                                        }),
                                                                        tl: /* [] */ 0
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var codeContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("flex"),
    tl: {
        hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .flexDirection */ .Me8("column"),
        tl: /* [] */ 0
    }
});
var title = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.75)),
    tl: {
        hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2({
            NAME: "num",
            VAL: 700
        }),
        tl: {
            hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2.5)),
            tl: {
                hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2("(max-width: 480px)", {
                    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }
});
var btn = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: bs_css_emotion_src_Css_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.blue400 */ .Il.blue400),
    tl: /* [] */ 0
});
var Styles = {
    nestedInput: nestedInput,
    codeContainer: codeContainer,
    title: title,
    btn: btn
};
function getSignupType(signupTypeValue) {
    switch(signupTypeValue){
        case /* GiftOpen */ 0:
            return "Gift Open";
        case /* DuringPurchase */ 1:
            return "During Purchase";
        case /* PostPurchaseForFriend */ 2:
            return "Post Purchase For Friend";
        case /* PostPurchaseForSelf */ 3:
            return "Post Purchase For Self";
        case /* SignupPage */ 4:
            return "Signup Page";
    }
}
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.memo(function(props) {
    var segmentData = props.segmentData;
    var purchaseCallback = props.purchaseCallback;
    var orderNumber = props.orderNumber;
    var signupType = props.signupType;
    var state = props.state;
    var match = _utils_FormReducer_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .useFormReducer */ .BZ(undefined);
    var formDispatch = match[1];
    var formState = match[0];
    var match$1 = react__WEBPACK_IMPORTED_MODULE_3__.useState(function() {
        return true;
    });
    var setCanResend = match$1[1];
    var canResend = match$1[0];
    var match$2 = _auth_user_UserContext_bs_js__WEBPACK_IMPORTED_MODULE_8__.useUser(undefined);
    var dispatchUserAction = match$2[1];
    var router = next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter();
    var layoutData = _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .useContext */ .qp(undefined);
    var registerData = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_22__/* .flatMap */ .VS(layoutData, function(o) {
        return o.register;
    });
    var registrationFlowSignupType = _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Registration.getSignupTypeAsString */ .YM.getSignupTypeAsString(signupType);
    var stepTitleSecurityCode = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_22__/* .mapWithDefault */ .k7(registerData, "<p>Please enter the security code we sent to you via SMS.</p>", function(c) {
        return c.stepTitleSecurityCode;
    });
    var resendCodeText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_22__/* .mapWithDefault */ .k7(registerData, "Resend code", function(c) {
        return c.resendCodeText;
    });
    var resendingCodeText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_22__/* .mapWithDefault */ .k7(registerData, "Please wait", function(c) {
        return c.resendingCodeText;
    });
    var signUpCtaText = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_22__/* .mapWithDefault */ .k7(registerData, "Sign up", function(c) {
        return c.signUpCtaText;
    });
    var form = _bindings_ReactHookForm_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .useForm */ .cI({
        mode: "onChange",
        defaultValues: {
            securityCode: null
        }
    }, undefined);
    var securityCodeControllerOptions = {
        name: "securityCode",
        control: form.control,
        rules: {
            required: {
                value: true,
                message: ""
            },
            minLength: {
                value: 6,
                message: ""
            }
        },
        defaultValue: null
    };
    var match$3 = react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useController */ .bc(securityCodeControllerOptions);
    var match$4 = match$3.field;
    var onChange = match$4.onChange;
    var getSecurityCode = react__WEBPACK_IMPORTED_MODULE_3__.useCallback(function(param) {
        _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_23__/* .then_ */ .k(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve(undefined);
            } else {
                return Promise.resolve(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(formDispatch, /* Error */ {
                    _0: {
                        TAG: /* SecurityCodeError */ 1,
                        _0: "An error occured. Please try again later."
                    }
                }));
            }
        }, _api_PrezzeePublicClient_bs_js__WEBPACK_IMPORTED_MODULE_16__.securityCode({
            email: _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(state.email),
            phoneNumber: _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(state.phoneNumber)
        }));
    }, [
        state.email,
        state.phoneNumber
    ]);
    var resend = react__WEBPACK_IMPORTED_MODULE_3__.useCallback(function(e) {
        e.preventDefault();
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(setCanResend, function(param) {
            return false;
        });
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(onChange, null);
        setTimeout(function(param) {
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(setCanResend, function(param) {
                return true;
            });
        }, 60000);
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(getSecurityCode, undefined);
    }, [
        getSecurityCode
    ]);
    var onSubmit = react__WEBPACK_IMPORTED_MODULE_3__.useCallback(function(data) {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(formDispatch, /* Submit */ 0);
        var firstName = _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(state.firstName);
        var lastName = _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(state.lastName);
        var email = _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(state.email);
        var phoneNumber = _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(state.phoneNumber);
        var currentDate = new Date().toISOString();
        _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_23__/* .then_ */ .k(function(result) {
            var tmp;
            if (result.TAG === /* Ok */ 0) {
                if (segmentData !== undefined) {
                    _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .customElementInteraction */ .pA(Object.assign({}, {
                        element: "sign_up_success",
                        signup_instance_id: segmentData.signup_instance_id,
                        path: segmentData.path,
                        signup_type: registrationFlowSignupType
                    }));
                }
                _auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .saveTokenCookie */ .iB({
                    userDetails: _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_24__/* .fromOption */ .Yo({
                        uid: null,
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phoneNumber: phoneNumber
                    }),
                    token: result._0.accessToken,
                    masquerade: undefined
                });
                _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(dispatchUserAction, {
                    TAG: /* Login */ 0,
                    _0: {
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phoneNumber: phoneNumber
                    }
                });
                setTimeout(function(param) {
                    _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_23__/* .then_ */ .k(function(res) {
                        var tmp;
                        if (res.TAG === /* Ok */ 0) {
                            var c = res._0;
                            _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .identifyWithContext */ .Dx(c.uid, {
                                user_type: "consumer",
                                first_name: c.firstName,
                                last_name: c.lastName,
                                phone: c.phone,
                                email: c.email,
                                id: c.uid,
                                username: c.email
                            }, false);
                            var signedUpSegmentData = {
                                user_type: "consumer",
                                created_at: currentDate,
                                username: c.email,
                                email: c.email,
                                first_name: c.firstName,
                                last_name: c.lastName,
                                phone: c.phone,
                                signup_type: getSignupType(signupType)
                            };
                            tmp = _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .signedUp */ .Tz(segmentData !== undefined ? Object.assign(signedUpSegmentData, {
                                signup_instance_id: segmentData.signup_instance_id
                            }) : signedUpSegmentData);
                        } else {
                            tmp = undefined;
                        }
                        return Promise.resolve(tmp);
                    }, _api_PrezzeeSecureClient_bs_js__WEBPACK_IMPORTED_MODULE_17__/* .getCustomerData */ .ck(undefined));
                }, 500);
                if (signupType === /* SignupPage */ 4 || signupType === /* PostPurchaseForSelf */ 3) {
                    router.push("/wallet");
                    tmp = undefined;
                } else if (signupType === /* PostPurchaseForFriend */ 2) {
                    router.push("/store");
                    tmp = undefined;
                } else {
                    tmp = signupType === /* GiftOpen */ 0 ? purchaseCallback !== undefined ? _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(purchaseCallback, undefined) : undefined : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(formDispatch, /* Success */ 1);
                }
            } else {
                var e = result._0;
                if (segmentData !== undefined) {
                    _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .customElementInteraction */ .pA(Object.assign({}, {
                        element: "sign_up_fail",
                        signup_instance_id: segmentData.signup_instance_id,
                        path: segmentData.path,
                        signup_type: registrationFlowSignupType
                    }));
                }
                switch(e.TAG | 0){
                    case /* NetworkError */ 0:
                    case /* JsonParsingError */ 1:
                        tmp = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(formDispatch, /* Error */ {
                            _0: /* UnexpectedError */ 0
                        });
                        break;
                    case /* ServerError */ 2:
                        var serverError = e._0;
                        tmp = typeof serverError === "number" || serverError.TAG !== /* ServerValidationError */ 0 ? _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(formDispatch, /* Error */ {
                            _0: /* UnexpectedError */ 0
                        }) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._1(formDispatch, /* Error */ {
                            _0: {
                                TAG: /* LoginError */ 0,
                                _0: serverError._0
                            }
                        });
                        break;
                }
            }
            return Promise.resolve(tmp);
        }, _api_PrezzeeSecureClient_bs_js__WEBPACK_IMPORTED_MODULE_17__/* .register */ .z2({
            firstName: firstName,
            lastName: lastName,
            email: email,
            phoneNumber: phoneNumber,
            password: _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(state.password),
            securityCode: _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(data.securityCode),
            marketingOptIn: state.marketingOptIn,
            orderNumber: orderNumber
        }));
    }, [
        state
    ]);
    var error = formState.error;
    var tmp;
    tmp = error !== undefined ? typeof error === "number" ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx(_Notification_bs_js__WEBPACK_IMPORTED_MODULE_10__.make, {
        notificationType: /* NotificationWarning */ 3,
        title: "Connection error",
        description: "Sorry, we can't reach prezzee at the moment, please check your internet connection",
        className: "w-full mb-4"
    }) : error.TAG === /* LoginError */ 0 ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx(_Notification_bs_js__WEBPACK_IMPORTED_MODULE_10__.make, {
        notificationType: /* NotificationInfo */ 1,
        title: "Login error",
        description: error._0,
        className: "w-full mb-4"
    }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx(_Notification_bs_js__WEBPACK_IMPORTED_MODULE_10__.make, {
        notificationType: /* NotificationInfo */ 1,
        title: "Resend error",
        description: error._0,
        className: "w-full mb-4"
    }) : null;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [
            tmp,
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs("form", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx("label", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx(_prezzee_ribbon_src_components_personal_RichText_RichText_bs_js__WEBPACK_IMPORTED_MODULE_19__.make, {
                            children: stepTitleSecurityCode
                        }),
                        className: _pages_register_steps_SignUpStepStyles_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .formLabel */ .Xv,
                        htmlFor: "security-code"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs("div", {
                        children: [
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx(_prezzee_ribbon_ui_lib_components_FormInputPin__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                pinLength: 6,
                                onChange: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__.__1(onChange),
                                value: _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .getValue */ .NA(match$4.value)
                            }),
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx("button", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .ReactStuff.s */ .p_.s(!formState.isSubmitting && canResend ? resendCodeText : resendingCodeText),
                                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_25__/* .make */ .S([
                                    !formState.isSubmitting && canResend ? "block text-sm w-full text-right underline mt-2" : "block text-sm w-full text-right mt-2",
                                    btn
                                ]),
                                disabled: formState.isSubmitting || !canResend,
                                type: "button",
                                onClick: resend
                            })
                        ],
                        className: codeContainer,
                        id: "security-code"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx(_prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_18__.make, {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx("button", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .ReactStuff.s */ .p_.s(signUpCtaText),
                            className: "mt-8",
                            disabled: formState.isSubmitting || !form.formState.isValid,
                            type: "submit"
                        })
                    })
                ],
                onSubmit: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_21__._2(form.handleSubmit, onSubmit, _utils_FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .onError */ .qQ)
            })
        ]
    });
});
 /* nestedInput Not a pure module */ 


/***/ }),

/***/ 96626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ nextButton; },
/* harmony export */   "Gr": function() { return /* binding */ formInput_; },
/* harmony export */   "TF": function() { return /* binding */ previousButton; },
/* harmony export */   "Xv": function() { return /* binding */ formLabel; },
/* harmony export */   "d7": function() { return /* binding */ tAndCs; },
/* harmony export */   "gB": function() { return /* binding */ nextButtonDisabled; },
/* harmony export */   "pb": function() { return /* binding */ list; },
/* harmony export */   "rD": function() { return /* binding */ submitBtn; }
/* harmony export */ });
/* unused harmony exports phoneInput, previousButtonIcon, nextButtonIcon, errorTextStyle */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92592);
/* harmony import */ var _css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93802);
// Generated by ReScript, PLEASE EDIT WITH CARE



var formInput_ = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("left"),
        tl: /* [] */ 0
    }
});
var formLabel = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("block"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("left"),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2)),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2)),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var errorTextStyle = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("block"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textAlign */ .ydu("left"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.75)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginBottom */ .yl7(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.5)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginLeft */ .oIA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(-2)),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.prezzeeRed */ .Il.prezzeeRed),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var tAndCs = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("a", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.red400 */ .Il.red400),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hover */ .MrM({
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textDecoration */ .QXS("underline"),
                tl: /* [] */ 0
            }),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .focus */ .T_4({
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .textDecoration */ .QXS("underline"),
                    tl: /* [] */ 0
                }),
                tl: /* [] */ 0
            }
        }
    }),
    tl: /* [] */ 0
});
var list = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("ul", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .listStyleType */ .jZR("disc")),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var phoneInput = "appearance-none rounded-lg border-2 text-gray-800 leading-tight ml-8 py-3 px-3 mb-4 outline-none w-full";
var previousButton = "text-black font-bold float-left mt-10 p-3 text-gray-500 focus:outline-none";
var previousButtonIcon = "mr-5 text-4xl text-gray-500";
var nextButton = "text-black font-bold float-right mt-10 p-3 focus:outline-none";
var nextButtonDisabled = "text-black font-bold float-right mt-10 p-3 text-gray-500 focus:outline-none cursor-not-allowed";
var nextButtonIcon = "ml-2 text-4xl text-prezzee-red";
var submitBtn = "mt-8";
 /* formInput_ Not a pure module */ 


/***/ }),

/***/ 50884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q3": function() { return /* binding */ getCleanPhoneNumber; }
/* harmony export */ });
/* unused harmony exports validateEmail, validateLoginPassword, validatePassword, optionalPhoneNumber, validatePhoneNumber, validatePhone */
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99813);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37712);
/* harmony import */ var _bindings_LibPhoneNumber_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10925);
// Generated by ReScript, PLEASE EDIT WITH CARE




function validateEmail(email) {
    if (email === "") {
        return {
            TAG: /* Error */ 1,
            _0: "Your email is required"
        };
    } else if (Regex.emailRegex.test(email)) {
        return {
            TAG: /* Ok */ 0,
            _0: email
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: "Please enter a valid email address"
        };
    }
}
function validateLoginPassword(password) {
    if (password === "") {
        return {
            TAG: /* Error */ 1,
            _0: "Password is required"
        };
    } else {
        return {
            TAG: /* Ok */ 0,
            _0: password
        };
    }
}
function validatePassword(password) {
    var passwordRegex = /^((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,100})$/;
    if (password === "") {
        return {
            TAG: /* Error */ 1,
            _0: "Password is required"
        };
    } else if (passwordRegex.test(password)) {
        return {
            TAG: /* Ok */ 0,
            _0: password
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: "Please retry with a more secure password. (Max: 100 Characters)"
        };
    }
}
function getCleanPhoneNumber(dirtyNumber) {
    return _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_2__/* .replaceByRe */ .jt(/\D+/g, "", dirtyNumber);
}
function optionalPhoneNumber(phoneNumber) {
    var phoneNumberRegex = /^([0-9]{5,13})$/;
    var cleanNumber = getCleanPhoneNumber(phoneNumber);
    if (phoneNumberRegex.test(cleanNumber)) {
        return {
            TAG: /* Ok */ 0,
            _0: "+" + cleanNumber
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: "Invalid phone number"
        };
    }
}
function validatePhoneNumber(phoneNumber) {
    var phoneNumberRegex = /^([0-9]{5,13})$/;
    var cleanNumber = getCleanPhoneNumber(phoneNumber);
    if (cleanNumber === "") {
        return {
            TAG: /* Error */ 1,
            _0: "Phone number is required"
        };
    } else if (phoneNumberRegex.test(cleanNumber)) {
        return {
            TAG: /* Ok */ 0,
            _0: "+" + cleanNumber
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: "Invalid phone number"
        };
    }
}
function validatePhone(countryCode, phone) {
    var validNumber = LibPhoneNumber.isValidPhoneNumber($$String.uppercase_ascii(countryCode), phone);
    var val;
    try {
        val = validNumber;
    } catch (exn) {
        if (phone === "") {
            return {
                TAG: /* Ok */ 0,
                _0: ""
            };
        }
        throw exn;
    }
    if (val) {
        return {
            TAG: /* Ok */ 0,
            _0: "+" + phone
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: "Please enter a valid mobile number"
        };
    }
}
 /* LibPhoneNumber Not a pure module */ 


/***/ }),

/***/ 47846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ lastNameInput; },
/* harmony export */   "GR": function() { return /* binding */ passwordInput; },
/* harmony export */   "Ls": function() { return /* binding */ emailInput; },
/* harmony export */   "Uk": function() { return /* binding */ firstNameInput; },
/* harmony export */   "Xk": function() { return /* binding */ prezzeeTnCInput; },
/* harmony export */   "g9": function() { return /* binding */ marketingOptInInput; },
/* harmony export */   "mj": function() { return /* binding */ nzTnCInput; }
/* harmony export */ });
/* harmony import */ var _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7618);
// Generated by ReScript, PLEASE EDIT WITH CARE

var firstNameInput = {
    required: {
        value: true,
        message: "First name is required"
    },
    pattern: {
        value: _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .notOnlySpaceRegex */ .qc,
        message: "Please enter a valid name"
    }
};
var lastNameInput = {
    required: {
        value: true,
        message: "Last name is required"
    },
    pattern: {
        value: _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .notOnlySpaceRegex */ .qc,
        message: "Please enter a valid name"
    }
};
var emailInput = {
    required: {
        value: true,
        message: "Your email is required"
    },
    pattern: {
        value: _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .emailRegex */ .HN,
        message: "Please enter a valid email address"
    }
};
var passwordInput = {
    required: {
        value: true,
        message: "Password is required"
    },
    pattern: {
        value: _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .passwordRegex */ .BV,
        message: "Please retry with a more secure password. (Max: 100 Characters)"
    }
};
var prezzeeTnCInput = {
    required: {
        value: true,
        message: "Please accept terms and conditions"
    }
};
var nzTnCInput = {
    required: {
        value: true,
        message: "Please make sure you have accepted the terms"
    }
};
var marketingOptInInput = {};
 /* No side effect */ 


/***/ }),

/***/ 40367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ useFormReducer; }
/* harmony export */ });
/* unused harmony exports initialState, reducer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25400);
// Generated by ReScript, PLEASE EDIT WITH CARE


var initialState = {
    isSubmitting: false,
    error: undefined
};
function reducer(param, action) {
    if (typeof action === "number") {
        if (action !== 0) {
            return initialState;
        } else {
            return {
                isSubmitting: true,
                error: undefined
            };
        }
    } else {
        return {
            isSubmitting: false,
            error: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_1__/* .some */ .G(action._0)
        };
    }
}
function useFormReducer(param) {
    return react__WEBPACK_IMPORTED_MODULE_0__.useReducer(reducer, initialState);
}
 /* react Not a pure module */ 


/***/ })

}]);